import React from "react";
import "./DesktopSearchPopup.css";

function DesktopSearchPopup() {
  return (
    <div className="container-center-horizontal">
      <div className="desktop-search-popup screen"></div>
    </div>
  );
}

export default DesktopSearchPopup;
